import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-comments-filter',
  templateUrl: './comments-filter.component.html',
  styleUrls: ['./comments-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SharedModule,
    MatCheckboxModule
  ]
})
export class CommentsFilterComponent {
  @Input() dataSource?:any;
  @Output() checkedItemsEmit = new EventEmitter();
  itemsPush:any = [];
  route = inject(ActivatedRoute);
  router = inject(Router);
  ngOnInit(): void {

    let params: any = this.route.snapshot.queryParams;
    let listParamsRev = params.reviews?.length > 1 ? params.reviews.split(',') : params.reviews?.split();

    if (params.reviews) {

      this.dataSource.forEach((item: any) => {
        listParamsRev.forEach((element: any) => {
          if (item?.Value == element) {
            item.checked = true
          }
        });
      })

    } else {
      this.dataSource.forEach((item: any) => {
        item.checked = false
      });
    }
  }

  changeSelected(val:string,ev:any){
    this.dataSource.forEach((item: any) => {
      if (item.checked && item.Value != val)
        this.itemsPush.push(item.Value)
      if (item.checked && item.Value == val)
        item.checked = false;
    });
    if (ev.checked && !this.itemsPush.includes(val)) {
      this.itemsPush.push(val);
    } else if (!ev.checked && this.itemsPush.includes(val)) {
      const index = this.itemsPush.indexOf(val);
      if (index > -1) { // only splice array when item is found
        this.itemsPush.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    let objSelected = {
      value: this.itemsPush,
      ev: ev,
      key:'reviews'
    }
    this.checkedItemsEmit.emit(objSelected);
    }


}
